export default     {
    path: '/dashboard/invoices',
    components: {
        default: () => import('../../views/memberDashboard/dashboard/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            redirect: '/dashboard/account/invoices' 
        },
    ]
}